module.exports = __webpack_public_path__ + "img/release-latest.da1d4aff.png";